import type { ComponentProps } from 'react';

/**
 * Renders user data (names, quotes, titles) with automatic direction, so Arabic runs right-to-left
 * inside the English layout and never reorders surrounding UI text (PLAN §12.1).
 */
export function DataText({ lang, className, ...props }: ComponentProps<'bdi'> & { lang?: string }) {
  return <bdi dir="auto" lang={lang} className={className} {...props} />;
}

/** Block-level data (quotes, paragraphs). */
export function DataBlock({ lang, className, ...props }: ComponentProps<'p'> & { lang?: string }) {
  return <p dir="auto" lang={lang} className={['text-start', className].filter(Boolean).join(' ')} {...props} />;
}

/** Dates, amounts, counts: tabular numbers, always LTR. */
export function DataNumber({ className, ...props }: ComponentProps<'span'>) {
  return <span dir="ltr" className={['tabular', className].filter(Boolean).join(' ')} {...props} />;
}
